import { css } from 'lit';

export const mapStyles = css`
.map {
  top:0px;
  left:0px;
  height:100%;
  width:100%;
  position:absolute;
}

.map-scale {
  right:4px;
  bottom: 4px;
  height:24px;
  border:1px solid lightgray;
  background: white;
  position:absolute;
  display:flex;
  align-items: center;
  font-size: 12px;
  padding-left: 4px
}

.map-scale input {
  width: 54px;
  font-size:12px;
  font-weight:bold;
}

.toolbar {
  position:absolute;
  top:0px;
  left:0px;
  right: 0px;
  height:var(--toolbar-height);
}

.toolbar .background{
  position:absolute;
  width:100%;
  height:100%;
  background: #f3f3f3;
  border-bottom: solid 1px #b5bcc7;
  opacity: 0.8;
}

.legend-panel {
  position: absolute;
  top:var(--toolbar-height);
  left:0px;
  bottom:0px;
  width:var(--legend-width);
  display:none;
}


.legend-panel.active {
  display:inherit;
}

.legend-panel .legend-panel-background{
  position:absolute;
  width:100%;
  height:100%;
  background: #f3f3f3;
  border-bottom: solid 1px #b5bcc7;
  opacity: var(--legend-opacity, 0.7);
}



.legend-panel .legend-panel-layers {
  position:absolute;
  inset:0px 6px 0px 0px;
  display:flex;
  flex-direction:column;
}

.legend-panel .panel-layers-header {
   height:40px; 
   direction:ltr;
}


.legend-panel .panel-layers-controls {
  flex:1;
  overflow-y:auto;
  overflow-x:hidden;

  direction: rtl;
}

.legend-panel .legend-resizer {
  width: 6px;
  cursor: ew-resize;
  position:absolute;
  top: 0px;
  right:0px;
  bottom:0px;
  border-left: 1px solid lavender;
  border-right: 1px solid lavender;
  background: white;
  opacity: 0.5;
}






.popup-content {
  font-size:12px;
}

.popup-content .layers table {
  width: 100%;
  padding-right: 4px;
}

.popup-content .selection {
  text-align: right;
}

.popup-content .selection button {
    padding: 2px;
    height: 24px;
    width: 24px;
    margin-top: -2px;
    cursor: pointer;
}

.popup-content .selection k-icon {
  --icon-size:16px;
}

.popup-content .sub {
  font-size: smaller;
  font-style: italic;
}

.popup-content .detail {
  display: flex;
}

.popup-content .detail .fill {
  flex: 1;
}

.popup-content .streetView, .popup-content .docsView  {
  display:inline-flex;align-items:center
}

.popup-content .streetView img, .popup-content .docsView img {
  height: 20px;margin-left: 8px;
}

`;

export const mapLegendStyles = css`
.legend-container {
  border: 1px solid #f0f0f0;
  padding: 2px;

  direction: ltr;
}

.legend-group {
  border:1px solid #f8f8f8;
  margin-right: 4px;
}

.legend-layers {
  margin-left: 12px;
  margin-right: 4px;
}

.legend-children {
  margin-left: 12px;
}

.legend-layer {
  border:1px solid #f8f8f8;
  background: rgba(255,255,255,0.6);
  box-shadow_: 2px 2px 3px 0px rgba(50, 50, 50, 0.5);
  margin-bottom: 4px;
}

.legend-header {
  display: flex;
  height: 26px;
  margin-top: 4px;
  margin-right: 4px;
}


.legend-header .legend-caption  {
  font-family: Arial;
  flex: 1;
  margin-right: 4px;
  overflow: hidden;
  font-weight: bold;
}


.legend-container > .legend-header .legend-caption {
  font-size: larger;
}

.legend-header .legend-caption .legend-label {
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/*
.legend-header .legend-caption .legend-label:hover  {
  overflow: visible;
  position: absolute;
  background: white;
}
*/

.legend-header .legend-display {
  display: inline-block;
  width: 24px;
}

.legend-buttons {
  display: flex;
  align-items:center;
}

.legend-tile-dynamic {
  padding: 0 20px;
}

.legend-tile-select {
  width:100%;
  padding:4px;
  margin-right: 16px;
  background:transparent;
  border:1px solid lightgray;
}



.legend-collapse, .legend-info {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 6px;
  cursor: pointer;
}

.legend-info {
  background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAABPElEQVQ4jaWTwUpCYRCFvxktw4eoFi6CuPkMZS5ypS18AQP30mtEEQUu9A2CXBmY9AZBSNe11M4XSExnWnQNk6sSndUPM+fMmeH8wgKClgdiduaQw9kFQBg4dBVt9E7ldb5fZo9M21NbH3YpQhXQReEIU6BuE62FZRn/CGTankqP/MHxwyXEBciTTeQkLMtYAdIju4oj90pKrxRnxo80YRcAErQ8wOwlzvaMfHBvseuoaTYZHSx25yXEGRKmVkk6HMdV562vEMorsL1qzBrsKOBxlTX2Z3AF3v/h4E0dHv8h0FFFG3wnbCnis8DUVJsaZbv+19ECt2FR+kkAm2hNk74HnptvWnpIke7GUM4hClBYlrFNpIBzs2adqcD15lAKz1X5jJz8RvbO902tAuQh+s4wADqm2gyL0p/v/wJOFHTacFgyhwAAAABJRU5ErkJggg==")
}


.legend-collapse.open {
  background-image: url("data:image/gif;base64,R0lGODlhEAAQAJEAAGyNom2Nov///wAAACH5BAAAAAAALAAAAAAQABAAAAInRI6ZJu3/DpxO0mljwBvm2mkcqIRZeYbg6KnN97oCfM3yReMGWgIFADs=");
}

.legend-collapse.close {
  background-image: url("data:image/gif;base64,R0lGODlhEAAQAJEAAGyNom2Nov///wAAACH5BAAAAAAALAAAAAAQABAAAAIkRI6ZJu3/DpxO0mlvDBrmLnwKV5HNuIGleprg18GafAXGiAMFADs=");
}


.legend-layer .legend-symbols {
  margin-left: 24px;
}

.legend-symbols .legend-symbol {
  display: flex;
  align-items: center;
}

.legend-symbol-image {
  display: inline-block;
  width: 70px;
}

.legend-symbol-caption {
  overflow: hidden;
  position: relative;
  flex: 1;
}

.legend-symbols .legend-symbol .legend-symbol-detail {
  display: none;
}


.legend-symbols .legend-symbol:hover {
}


/*
.legend-symbols .legend-symbol:hover .legend-symbol-caption {
  overflow: visible;
  background: white;
  border: 1px solid #f0f0f0;
  padding: 6px;
  box-shadow: 1px 1px 5px 1px rgba(0,0,0,0.1);
}
*/

.legend-symbol-caption .legend-label {
  margin-left: 4px;
  font-size: 13px;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;  
}




.legend-container input[type=range] {
  /*removes default webkit styles*/
  -webkit-appearance: none;

  /*fix for FF unable to apply focus style bug */
  border: 1px solid white;

  /*required for proper track sizing in FF*/
  width: 95%;
}

.legend-container input[type=range]::-webkit-slider-runnable-track {
  height: 5px;
  background: #ddd;
  border: none;
  border-radius: 3px;
}
.legend-container input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  border: none;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background: gray;
  margin-top: -6px;
  box-shadow: 1px 1px 5px 1px rgba(0,0,0,0.4);
}

.legend-container input[type=range]:focus {
  outline: none;
}
.legend-container input[type=range]:focus::-webkit-slider-runnable-track {
  background: #ccc;
}

.legend-container input[type=range]::-moz-range-track {
  width: 100%;
  height: 5px;
  background: #ddd;
  border: none;
  border-radius: 3px;
}
.legend-container input[type=range]::-moz-range-thumb {
  border: none;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background: gray;
}

/*hide the outline behind the border*/
.legend-container input[type=range]:-moz-focusring{
  outline: 1px solid white;
  outline-offset: -1px;
}



`